<mat-radio-group
  [(ngModel)]="selectedAccount"
  (ngModelChange)="onSelectionChange($event)"
  class="radio-button-list"
  [attr.aria-label]="'ARIA_LABEL.SELECT_PAYMENT_METHOD' | translate"
>
  @for (linkedFi of userProfile?.linked_fi_info; track linkedFi; let i = $index; let isLast = $last) {
  <div class="payment-method-container width-border-box" [ngClass]="{'payment-method-container__refresh-error': linkedFi?.refresh_token_expired}">
    <div class="payment-method-container__fi">
      <pbb-bank-info
        id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_bank_info"
        [fi]="linkedFi.display_name"
        [logo]="linkedFi.logo"
        [showName]="true"
        [size]="40"
        [noAccounts]="!linkedFi.accounts?.length && !linkedFi.refresh_token_expired"
        [expiredRefreshToken]="linkedFi?.refresh_token_expired && linkedFi?.accounts?.length === 0"
      ></pbb-bank-info>
      @if ((userProfile?.linked_fi_info ?? []).length > 1 && !isCheckout && !linkedFi?.refresh_token_expired) {
      <pbb-menu
        idLabel="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}"
        [options]="[
          {
            action: Action.UNLINK,
            label: 'COMMON.PAYMENT_METHOD.FI.MENU.UNLINK',
            icon: 'link_off',
            showConfirm: true,
            confirmTitle: ['COMMON.UNLINK_FI.UNLINK_BANK', { bankName: linkedFi.display_name }],
            confirmSubtitle: ['COMMON.UNLINK_FI.UNLINK_BANK_INFO', { bankName: linkedFi.display_name }],
            confirmButton: 'COMMON.UNLINK_FI.BUTTON.UNLINK',
            confirmColor: 'warn',
            logo: linkedFi.logo,
            showLogo: true,
            closeOnSuccess: true,
            confirmCancel: ['COMMON.BUTTON.CANCEL'],
            dialogSuccessMessageParams: { displayName: linkedFi.display_name }
          }
        ]"
        [item]="linkedFi"
        [itemRef]="linkedFi.linked_fi_id"
        [menuAriaLabel]="linkedFi.display_name"
        [itemIndex]="i"
        (menuAction)="menuAction.emit($event)"
      ></pbb-menu>
      }
    </div>

    @if (linkedFi.accounts?.length) {
    <hr class="mt-16 mb-16" />
    } @if(linkedFi?.refresh_token_expired && linkedFi?.accounts?.length === 0) {
    <ng-container *ngrxLet="userProfileRef$ as userProfileRef">
      <hr class="mt-16 mb-16" />
      <div class="payment-method-container__expired-token" id="{{ linkedFi.display_name | idFormat }}_expired_token">
        <pbb-button
          [size]="'L'"
          [pbbButtonType]="'primary-alternate'"
          [pbbButtonId]="'payment-method-unlink-btn'"
          [cssClass]="'btn-stroked-no-border'"
          (clicked)="unlinkFi(linkedFi)"
        >{{'COMMON.UNLINK_FI.BUTTON.UNLINK' | translate}}</pbb-button>
          
        <pbb-button
          [size]="'L'"
          [pbbButtonType]="'primary'"
          [pbbButtonId]="'payment-method-relink-btn'"
          (clicked)="relinkFI(linkedFi, userProfileRef)"
        >
          <mat-icon aria-hidden="true" class="icon-smd mr-4">refresh</mat-icon>
          <span class="vertical-align-text-top">
            {{ 'COMMON.UNLINK_FI.BUTTON.RELINK' | translate }}
          </span>
        </pbb-button>
      </div>
    </ng-container>
    }

    <div class="payment-method-container__fi-account-list" id="{{ linkedFi.display_name | idFormat }}_account_list">
      @for (account of linkedFi.accounts; track account; let accountIndex = $index) { @let radioValue = {
      selectedAccountId: account.fi_account_ref, selectedFiId: linkedFi.linked_fi_id, selectedFiUserId:
      linkedFi.fi_user_id } | jsonStringify;

      <pbb-radio
        [id]="
          (linkedFi.display_name | idFormat) +
          '_' +
          linkedFi.fi_user_id +
          '_' +
          (account.display_name_en | idFormat) +
          '_' +
          account.account_last_digits +
          '_' +
          accountIndex
        "
        labelPosition="before"
        [disabled]="!!account.disable_reason"
        [value]="radioValue"
        [checked]="selectedAccount === radioValue"
        [cssClass]="'mat-body-2 background-transparent flex-label-radio' + (!!account.disable_reason ? 'disabled' : '')"
      >
        <div class="payment-method-container__fi-account-radio-container">
          <div class="payment-method-container__fi-account">
            <span
              class="payment-method-display-name{{
                userProfile?.default_fi_account_ref === account.fi_account_ref ? ' default' : ''
              }}"
              id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_{{
                account.display_name_en | idFormat
              }}_{{ account.account_last_digits }}_{{ accountIndex }}_text"
              >{{ account.displayName || '' | translate }}@if (userProfile?.default_fi_account_ref ===
              account.fi_account_ref) {<span class="sr-only">, {{ 'COMMON.DEFAULT' | translate }}, </span>}</span
            >
            <span
              class="payment-method-type mt-8 mb-6"
              id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_{{
                account.display_name_en | idFormat
              }}_{{ account.account_last_digits }}_{{ accountIndex }}_type_digits"
              ><span class="cc-bullet" aria-hidden="true">••••</span>{{ 'FI.ACCOUNT.ENDING_IN' | translate }}
              {{ account.account_last_digits }}</span
            >
            <div class="payment-method-logo flex-row width-fit-content">
              <pbb-svg-icon
                id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_{{
                  account.display_name_en | idFormat
                }}_{{ account.account_last_digits }}_{{ accountIndex }}_logo"
                alt=""
                width="20px"
                height="20px"
                [icon]="account.accountLogo || ''"
              ></pbb-svg-icon
              >&nbsp; @if(account.account_type === accountType.BankAccountChequing || account.account_type ===
              accountType.BankAccountSavings || account.account_type === accountType.BankAccountLineOfCredit) {
              <span
                class="payment-method-type break-anywhere"
                id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_{{
                  account.display_name_en | idFormat
                }}_{{ account.account_last_digits }}_{{ accountIndex }}_interac_direct"
                [innerHTML]="'COMMON.PAYMENT_METHOD.INTERAC_DIRECT' | translate"
              >
              </span>
              }
            </div>

            @if (account.disable_reason) {
            <p class="preline">{{ 'FI.ACCOUNT.DISABLE_REASON.' + account.disable_reason | translate }}</p>
            }
          </div>
        </div>
        @if (userProfile?.default_fi_account_ref === account.fi_account_ref) {
        <mat-chip-listbox tabindex="-1" aria-hidden="true">
          <mat-basic-chip
            class="default-chip success-chip"
            id="{{ linkedFi.display_name | idFormat }}_{{ linkedFi.fi_user_id }}_{{
              account.display_name_en | idFormat
            }}_{{ account.account_last_digits }}_{{ accountIndex }}_default_chip"
            tabindex="-1"
            ><span class="mat-caption">{{ 'COMMON.DEFAULT' | translate }}</span>
          </mat-basic-chip>
        </mat-chip-listbox>
        }
      </pbb-radio>

      @if (!$last) {
      <hr class="mt-16 mb-16" />
      } }
    </div>
  </div>
  }
</mat-radio-group>
@if(displayButtons) { @if (showSave) {
<div appStickyButton="#footer" class="sticky-container">
  <div class="sticky-main">
    <pbb-button
      [size]="'L'"
      [pbbButtonType]="'primary'"
      [pbbButtonId]="'payment-method-save-btn'"
      (clicked)="saveSelection()"
      (keyup.enter)="saveSelection()"
      (keyup.space)="saveSelection()"
    >
      {{ 'COMMON.BUTTON.SAVE' | translate }}
    </pbb-button>
  </div>
</div>
} @if (showContinue) {
<div appStickyButton="#footer" class="sticky-container">
  <div class="sticky-main">
    <pbb-button
      [size]="'L'"
      [pbbButtonType]="'primary'"
      [pbbButtonId]="'payment-method-continue-btn'"
      (clicked)="onContinue()"
      (keyup.enter)="onContinue()"
      (keyup.space)="onContinue()"
    >
      {{ 'COMMON.BUTTON.CONTINUE' | translate }}
    </pbb-button>
  </div>
</div>
} }
